import React from 'react';

export const Logo = () => {
	return (
		<img src="/logo.svg" alt="Konfuzio Chat Logo" style={{ height: '100%' }}/>
	);
};
